import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.sass']
})
export class ResetPasswordComponent implements OnInit {


  public selectedLanguageFlag: string = 'es';

  showPasswordResetProgressSpinner: boolean = true;
  hide: boolean = true;
  success: boolean = false;

  error: any = { show: false }

  resetPasswordForm: FormGroup;
  private oobCode: string;
  private mode: string;

  constructor(
    private fb: FormBuilder,
    private auth: AngularFireAuth,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private snackbar: MatSnackBar) {

    this.resetPasswordForm = fb.group({
      password: new FormControl('', Validators.required),
      password_repeat: new FormControl('', Validators.required)
    })

  }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      if (params.mode && params.oobCode) {

        this.auth.verifyPasswordResetCode(params.oobCode).then(() => {

          this.oobCode = params.oobCode
          this.mode = params.mode

          this.showPasswordResetProgressSpinner = false

        }).catch(err => {
          console.log(err)
          this.error.show = true
          this.showPasswordResetProgressSpinner = false
          throw new Error(err.code)
        })

      } else {
        // Reroute to login if required params are not present
        this.router.navigate(['/login']);

      }
    })

    // if (localStorage.getItem('language')) {
    //   this.selectedLanguageFlag = localStorage.getItem('language');
    // }
    // else {
    //   this.selectedLanguageFlag = 'es'
    // }
    this.selectedLanguageFlag = this.translate.currentLang

  }


  resetPassword(form: FormGroup) {

    if (!form.valid) {

      this.translate.get('alerts.data_input_error').subscribe((res: string) => {

        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })

      })



      throw new Error('Datos introducidos no son correctos')
    }

    if (form.value.password !== form.value.password_repeat) {

      this.translate.get('alerts.password_mismatch').subscribe((res: string) => {

        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })

      })

      throw new Error('Password inputs do not match')
    }

    let newPassword = form.value.password

    this.auth.confirmPasswordReset(this.oobCode, newPassword).then(() => {

      // alert('Se ha cambiado la contraseña exitosamente')

      // this.router.navigate(['/login'])

      this.success = true;

    }).catch(err => {
      this.translate.get('alerts.password_reset_error').subscribe((res: string) => {

        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })

      })
      throw new Error(err)
    })


  }

  changeLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    this.selectedLanguageFlag = lang
  }

}
